import { defineComponent as _defineComponent } from 'vue'
import { Image } from '~/types/strapi/image';
interface Props {
  bgImage?: Image;
  fgImage?: Image;
  subtitle?: string;
  title: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CollectionHero',
  props: {
    bgImage: { default: () => ({
    url: 'https://www.teachstarter.com/images/patterns/pink_grid.png',
    alternativeText: null,
    width: 1137,
    height: 640,
  }) },
    fgImage: { default: undefined },
    subtitle: { default: undefined },
    title: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})